import React, { FC, useMemo } from 'react';
import { AnalyticsUniqueUsersProps } from './AnalyticsUniqueUsersProps';
import { BarChartPro } from '@mui/x-charts-pro/BarChartPro';
import AnalyticsLoader from '../AnalyticsLoader';
import { sumByDate, sumByMonth } from './utils';

const AnalyticsUniqueUsers: FC<AnalyticsUniqueUsersProps> = ({
  data,
  grouping,
  loading,
}) => {
  const chartData: any = useMemo(() => {
    if (grouping && grouping === 'month') {
      return sumByMonth(data);
    }

    return sumByDate(data);
  }, [data, grouping]);

  return (
    <AnalyticsLoader loading={loading}>
      <BarChartPro
        dataset={chartData}
        xAxis={[
          {
            scaleType: 'band',
            data: chartData.map((dataPiece) => dataPiece.date),
            tickLabelStyle: { angle: -45 },
          },
        ]}
        yAxis={[
          {
            dataKey: 'number',
          },
        ]}
        series={[{ dataKey: 'number' }]}
        slots={{
          noDataOverlay: () => null,
        }}
      />
    </AnalyticsLoader>
  );
};

export default AnalyticsUniqueUsers;
